import { render, staticRenderFns } from "./area-facility.vue?vue&type=template&id=0eac72a8&scoped=true"
import script from "./area-facility.vue?vue&type=script&lang=js"
export * from "./area-facility.vue?vue&type=script&lang=js"
import style0 from "./area-facility.vue?vue&type=style&index=0&id=0eac72a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eac72a8",
  null
  
)

export default component.exports